import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'agenda-customer-ui-list-options-radio',
    standalone: true,
    imports: [CommonModule, TranslateModule],
    templateUrl: './list-options-radio.component.html',
    styleUrls: ['./list-options-radio.component.scss'],
    providers: [TranslateService],
})
export class ListOptionsRadioComponent implements OnInit {
    @Input() listOptions: any[] = [];
    @Output() optionChange = new EventEmitter<any>();
    optionSelected: any;

    constructor() { }

    ngOnInit(): void { }

    onOptionChange(listOption: any) {
        this.optionSelected = listOption;
        this.optionChange.emit(listOption);
    }
}
